namespace Matrix.Data {
    export class PartyRolePartyColumns {
        static columnsKey = 'Data.PartyRoleParty';
    }
}
